import React, { useEffect, useState } from "react";
import { Flame } from "lucide-react";
import { apiGet } from "@/lib/api";
import { EVENT } from "@/lib/data";

const pad = (n) => String(n).padStart(2, "0");

const HypeBanner = () => {
  const [hype, setHype] = useState(null);
  const [now, setNow] = useState(Date.now());

  useEffect(() => {
    const load = () => apiGet("/api/hype").then(setHype).catch(() => {});
    load();
    const poll = setInterval(load, 30000);
    const tick = setInterval(() => setNow(Date.now()), 1000);
    return () => {
      clearInterval(poll);
      clearInterval(tick);
    };
  }, []);

  if (!hype) return null;

  const diff = Math.max(new Date(EVENT.showTimeISO).getTime() - now, 0);
  const d = Math.floor(diff / 86400000);
  const h = Math.floor((diff % 86400000) / 3600000);
  const m = Math.floor((diff % 3600000) / 60000);
  const s = Math.floor((diff % 60000) / 1000);
  const pct = Math.min(100, Math.round((hype.seats_sold / hype.seats_total) * 100));

  return (
    <div
      data-testid="hype-banner"
      className="relative border-y border-[#D4AF37]/30 bg-[#0E142B]/90 overflow-hidden"
    >
      <div className="max-w-7xl mx-auto px-5 sm:px-8 py-4 flex flex-col md:flex-row items-center justify-between gap-4">
        <div className="flex items-center gap-3 text-center md:text-left">
          <span className="relative shrink-0 hidden sm:flex w-9 h-9 rounded-full bg-[#F59E0B]/10 border border-[#F59E0B]/40 items-center justify-center">
            <Flame size={16} className="text-[#F59E0B] flame-flicker" />
          </span>
          <div>
            <p className="text-[10px] uppercase tracking-[0.28em] text-[#F59E0B]">
              Live demand · seats are moving
            </p>
            <p className="text-sm text-[#FDFBF7] font-light mt-0.5">
              <span className="font-bold text-[#F3D068]" data-testid="hype-claimed">
                {hype.seats_sold.toLocaleString()}
              </span>{" "}
              seats already claimed — only{" "}
              <span className="font-bold text-[#F3D068]" data-testid="hype-remaining">
                {hype.seats_remaining.toLocaleString()}
              </span>{" "}
              of {hype.seats_total.toLocaleString()} remain
            </p>
          </div>
        </div>

        <div className="flex items-center gap-5 w-full md:w-auto">
          <div className="flex-1 md:w-56">
            <div className="h-1.5 rounded-full bg-white/10 overflow-hidden" data-testid="hype-progress-bar">
              <div
                className="h-full rounded-full bg-gradient-to-r from-[#7C74F2] via-[#D4AF37] to-[#F3D068] transition-all duration-1000"
                style={{ width: `${Math.max(pct, 4)}%` }}
              />
            </div>
            <p className="text-[10px] text-[#8A99B5] mt-1.5 text-right">{pct}% of the house claimed</p>
          </div>
          <div className="shrink-0 text-right">
            <p className="text-[10px] uppercase tracking-[0.2em] text-[#8A99B5]">Showtime in</p>
            <p className="font-cinzel text-sm text-[#F3D068] tabular-nums" data-testid="hype-countdown">
              {d}d {pad(h)}h {pad(m)}m {pad(s)}s
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default HypeBanner;
